import { Layout } from 'antd'
import TopHeader from './components/TopHeader'
import './styles.scss'

const { Header } = Layout

const HeaderMain = () => {
  return (
    <div className="header-main">
      <TopHeader />
    </div>
  )
}

export default HeaderMain
